// extracted by mini-css-extract-plugin
module.exports = {"camp":"Camp_camp__hTy2c"};